import { Component, OnInit } from "@angular/core";
import { LogClass, Logger } from "../../logger";

@Component({
    selector: "circ-page-general-error",
    templateUrl: "./page-general-error.component.html",
    styleUrls: ["./page-general-error.component.scss"],
    standalone: false
})
@LogClass({ source: "PageGeneralErrorComponent" })
export class PageGeneralErrorComponent implements OnInit {
  public error = ["Unknown error."];

  private logger: Logger;

  constructor() {
    this.logger.debug("ctor");
  }

  public ngOnInit(): void {
    let { message } = window.history.state;

    if (!message) {
      return; // unknown error...
    }

    if (typeof message === "object") {
      message = message.toString();
    }

    this.error = message.split("\n");
  }
}
